module.exports = __webpack_public_path__ + "static/img/hyzz3.10c0459f.png";